var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 py-3 shadow-custom",staticStyle:{"z-index":"10"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }